<template>
  <div class="max-w-content-sm md:max-w-content-xl mx-auto mb-10 lg:mb-15">
    <div class="p-2.5 sm:px-5 xl:px-0 sm:py-5 sm:grid grid-cols-2 md:grid-cols-3 gap-4">
      <div v-for="(country, index) in countries" :key="index" class="w-full mb-2.5 md:mb-0">
        <country-preview :country="country"></country-preview>
      </div>
    </div>
    <div v-if="loading" class="mt-8">
      <p class="text-center text-18 md:text-20">Finding Countries...</p>
    </div>
    <button
      v-else-if="showLoadMore"
      class="button block my-5 mx-auto min-w-280 md:min-w-360"
      @click.prevent="loadNextPage"
    >
      View more countries
    </button>
    <div v-if="error" class="py-5 md:py-15 text-center mx-auto max-w-screen-sm lg:max-w-content-sm">
      <p class="text-18 md:text-20">
        {{ error }}
      </p>
      <button class="button block mx-auto min-w-280 md:min-w-360" @click.prevent="getCountries">
        Try again
      </button>
    </div>
  </div>
</template>

<script>
import Route from '../src/Route';
import CountryPreview from './CountryPreview.vue';

export default {
  components: { CountryPreview },

  data() {
    return {
      error: null,
      countries: [],
      currentPage: 1,
      loading: false,
      perPage: 18,
      total: null,
    };
  },

  computed: {
    showLoadMore() {
      return ((this.total !== null)
        && (this.total !== this.countries.length)
        && !this.error);
    },
  },

  created() {
    this.getCountries();
  },

  methods: {
    getCountries() {
      console.log(this.total, this.countries.length, this.error);

      this.loading = true;
      this.error = null;

      axios
        .get(Route('json.countries.index'), {
          params: Object.assign(
            {
              per_page: this.perPage,
              page: this.currentPage,
            },
            this.searchParams
          )
        })
        .then((response) => {
          if (response.status === 200) {
            this.total = response.data.total;
            this.countries = [...this.countries, ...response.data.countries];
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem loading countries.';
        })
        .then(() => {
          this.loading = false;
        });
    },

    loadNextPage() {
      ++this.currentPage;
      this.getCountries();
    },
  },
}
</script>
